export var leftSideTools;
(function (leftSideTools) {
    leftSideTools["selection"] = "selection";
    leftSideTools["text"] = "text";
    leftSideTools["pen"] = "pen";
    leftSideTools["math"] = "math";
    leftSideTools["highlighter"] = "highlighter";
    leftSideTools["pencil"] = "pencil";
    leftSideTools["eraser"] = "eraser";
    leftSideTools["eraserAll"] = "eraserAll";
    leftSideTools["line"] = "line";
    leftSideTools["shapes"] = "shapes";
    leftSideTools["colorPlate"] = "colorPlate";
    leftSideTools["settings"] = "settings";
})(leftSideTools || (leftSideTools = {}));
